export const archive = () => (
  <path
    d="M21 8v13H3V8m7 4h4M1 3h22v5H1V3z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
